(function Module() {
	'use strict';
	const {_,mySynchEnumeration,moment} = require('../../globals');

    angular.module('mySynch').component('farmSelect',{
        template: `<ng-include src="'../partials/app/components/select-farm.view.html'"></ng-include>`,
        scope: {},
        bindings: {

        },
        controller: [ 
        'MySynchFactory',
        'ApiFactory',
        'ViewAuthorizationFactory',
        'F360Constant',
        'mySynchDataStore',
        'broadCastService',
        'pageTrackerService',
        'mySynchEnumerationService'
        , function(MSF,api,viewAuth,constant,mysynchDataStore,broadCastSrv,pageTracker,mySynchEnumSvc){
           
            this.MSF = MSF;
            this.api  = api;
            this.mysynchDataStore = mysynchDataStore;
            this.broadCastSrv = broadCastSrv;
            this.mySynchEnumSvc = mySynchEnumSvc;
            this.viewAuth = viewAuth;
            this.constant = constant;
            this._ = _;
            this.useTypeAhead = false;

           this.typeaheadSelectedFarmOptions = {
            debounce: {
              default: 500,
              blur: 250
            },
            getterSetter: true
          };
            this.defaultInputsTpl = {selectedFarm: null};
            this.prevAutoSelectedFarm = {};
            this.prevSelectedFarm = {selectedFarm: null};
            this.inputs = {selectedFarm: null};
            this.availableFarms = [];

            this.updateAvailableFarmsInterval = undefined;

            this.currentPageType = undefined;

            this.getTruncatedFarmName = function getTruncatedFarmName(farmName){
				var truncatedFarmName = farmName;
				if(truncatedFarmName.length > 30){
					var ellipsis = "...";
					var farmNameFirstPart = truncatedFarmName.slice(0,12);
					var farmNameSecondPart = truncatedFarmName.slice(16,truncatedFarmName.length);
					if(farmNameSecondPart.length > 14){
						var extraTrimLength = farmNameSecondPart.length-14;
						farmNameSecondPart = farmNameSecondPart.slice(extraTrimLength,farmNameSecondPart.length);
					}
					truncatedFarmName = farmNameFirstPart+ellipsis+farmNameSecondPart;
				}  
				
				return truncatedFarmName;
			};
            
			this.buildFarmNameDisplay = function buildFarmNameDisplay(farms) {
				_.forEach(farms,(farm)=> {
					 _.set(farm,'displayName',this.getTruncatedFarmName(_.get(farm,'name')));
				});
			};

            this.initializeSelectFarm = function initializeSelectFarm(){
                var currentFarm = this.MSF.getActiveFarm();
                
                if (!_.isEmpty(currentFarm) && _.isNull(_.get(this.inputs,'selectedFarm'))) {
					this.inputs.selectedFarm = _.find(this.availableFarms, {farmId: currentFarm.farmId});
                    this.prevSelectedFarm.selectedFarm = _.cloneDeep(this.inputs.selectedFarm);
				} 
            }

            this.refresh = function refresh() {
                this.availableFarms = this.MSF.getAvailableFarms();
				this.buildFarmNameDisplay(this.availableFarms);
            }

            

            this.typeaheadFarmSelected = function typeaheadFarmSelected(selectedFarm,model,label,event) {
				if(!_.isUndefined(selectedFarm) && !_.isNull(selectedFarm)){
                    if(_.isNull(_.get(this.prevSelectedFarm,'selectedFarm'))){
                         this.broadCastSrv.sendEnableSingleFarmLinksMsg("");
                    }
					this.inputs.selectedFarm = selectedFarm;
					this.prevAutoSelectedFarm = {};
                    _.set(this.prevSelectedFarm,'selectedFarm',_.cloneDeep(_.get(this.inputs,'selectedFarm')));
					this.farmChanged();
				}
				
			};
			this.typeaheadFilter = function typeaheadFilter(search) {	
                var searchField = this.MSF.currentUserIsDemoUser() ? 'farmId' : 'name';
               return function(farm){	
                      
						var searchValue = _.get(farm,searchField);
                        if(_.isEqual(searchField,'name')){
                            searchValue = searchValue.toLowerCase();
                        }
						return !_.isUndefined(searchValue) && !_.isUndefined(searchValue) && _.startsWith(searchValue,search.toLowerCase());        				
			          };
			};
			this.getTypeAheadLabel = function getTypeAheadLabel(farm) {
			
				return _.get(farm,'name');
			};
			
			this.onTypeAheadFocusIn = function onTypeAheadFocusIn(event) {
				this.prevAutoSelectedFarm = _.cloneDeep(this.inputs.selectedFarm);
				this.inputs.selectedFarm= {displayName:"",farmId:""};
			};
			this.onTypeAheadFocusOut = function onTypeAheadFocusOut(event) {
					
				var activeTextInput = $(_.get(event,"currentTarget"));
                
				var clickedOnTarget = $(event.relatedTarget);
                
				if(!_.isUndefined(clickedOnTarget) && clickedOnTarget.length > 0){
					var typeaheadInputAnc = clickedOnTarget.closest(".typeahead-input-container").find(".mysynch-typeahead-input");
					if((!_.isUndefined(typeaheadInputAnc) && typeaheadInputAnc.length > 0) && typeaheadInputAnc.is(activeTextInput)){
						return;
					}
				}

				var dropdownMenuJObj = activeTextInput.siblings(".dropdown-menu");
				if(dropdownMenuJObj.length > 0){
					dropdownMenuJObj.scrollTop(0);
				}
				if(!_.isEmpty(this.prevAutoSelectedFarm)){
                    _.set(this.inputs,'selectedFarm',_.cloneDeep(this.prevAutoSelectedFarm));
				}
			};
			
			this.onDropdownFarmSelect = function onDropdownFarmSelect(){
                if(_.isNull(_.get(this.prevSelectedFarm,'selectedFarm'))){
                    this.broadCastSrv.sendEnableSingleFarmLinksMsg("");
                }

                _.set(this.prevSelectedFarm,'selectedFarm',_.cloneDeep(_.get(this.inputs,'selectedFarm')));
				this.farmChanged();
            }
			

		
			this.farmChanged = function farmChanged(){
				if (this.MSF.lists.availableFarms.length && this.inputs.selectedFarm) {
					this.MSF.setActiveFarm(this.inputs.selectedFarm);
					this.loading = true;

					if (window.navigator.onLine) {
						this.api.getHerdsByFarmId(this.inputs.selectedFarm.farmId, (err, herds) => {
							this.loading = false;

							if (err) {
								log.error('Failed to get herds by farmId.' + err);
								this.MSF.notify.danger('Unable to load herd data');
	
								return this.MSF.setActiveHerd(null);
							}

							this.MSF.getActiveFarm().herds = herds;
							
							if (!_.any(herds, {herdId: (this.MSF.getActiveHerd() || {}).herdId})) {
								if (_.isEmpty(herds)) {
									return this.MSF.setActiveHerd(null);
								}
	
								this.MSF.setActiveHerd(herds[0]);	//	make first herd active
							}
							var personKey	= this.MSF.cookies.user.PersonKey;
							var herdKey		= this.MSF.activeHerd.herdKey;
							
							if (!herdKey) {
								herdKey = this.MSF.cookies.state.activeFarm.herds[0].herdKey;
							}
	                      
							if (personKey && herdKey) {
								pageTracker.trackPageView(personKey, herdKey, '(Farm Dropdown Changed)');	// no need to pass a callback because this is fire and forget
							}

                             if(_.isEqual(this.currentPageType,"MultiFarm")){
                                 var hms = _.get(this.MSF.getActiveHerd(),'herdMgmtSoftware');
                                 if(!_.isUndefined(hms) && !_.isNull(hms)){
                                     var navigationPage = (_.isEqual(hms,'DC305')) ? 'KpiDashboard' : 'FarmGoalManagement';
                                     this.MSF.loadPage(navigationPage);
                                 }
                             }
						});
					} else {
						this.indexedDB.readData(this.constant.getListherds, this.constant.getListherds,(err, herds) =>{
							if (err) {
								console.log('err', err);
							}
							this.loading = false;
							var herd = herds.filter(item => item.farmId == this.inputs.selectedFarm.farmId);
							if (herd && herd.length > 0) {
								this.MSF.getActiveFarm().herds = herd;
		
								if (!_.any(herd[0], {herdId: (this.MSF.getActiveHerd() || {}).herdId})) {
									if (_.isEmpty(herds)) {
										return this.MSF.setActiveHerd(null);
									}
		
									this.MSF.setActiveHerd(herd[0]);	//	make first herd active
								}
								var personKey	= this.MSF.cookies.user.PersonKey;
								var herdKey		= this.MSF.activeHerd.herdKey;
		
								if (!herdKey) {
									herdKey = this.MSF.cookies.state.activeFarm.herd[0].herdKey;
								}
		                      
								if (personKey && herdKey) {
									pageTracker.trackPageView(personKey, herdKey, '(Farm Dropdown Changed)');	// no need to pass a callback because this is fire and forget
								}

                                if(_.isEqual(this.currentPageType,"MultiFarm")){
                                    var hms = _.get(this.MSF.getActiveHerd(),'herdMgmtSoftware');
                                    if(!_.isUndefined(hms) && !_.isNull(hms)){
                                        var navigationPage = (_.isEqual(hms,'DC305')) ? 'KpiDashboard' : 'FarmGoalManagement';
                                        this.MSF.loadPage(navigationPage);
                                    }
                                }
							}
						});
					}
				}
			};

            this.clearFarmSelection = function clearFarmSelection(){
                  this.inputs = _.cloneDeep(this.defaultInputsTpl);
                  this.prevSelectedFarm = _.cloneDeep(this.defaultInputsTpl);
            }

        this.$onDestroy = function(){
           console.log("$$$$$$$$$$$$ select farm was destroyed $$$$$$$$$$");
            if(!_.isUndefined(this.updateAvailableFarmsInterval)){
                clearInterval(this.updateAvailableFarmsInterval); 
            };
        }
		
        this.$onInit = function(){

        
            MSF.ready(() => {
                this.isSuperAdmin = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
                this.isTM = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
                this.isParnellViewer = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER'));
                this.isDemoUser = this.MSF.currentUserIsDemoUser();
                this.useTypeAhead = (this.isSuperAdmin || this.isTM || this.isParnellViewer || this.isDemoUser) ? true : false;
             
                this.refresh();
                this.initializeSelectFarm();
                
                this.mysynchDataStore.currentActiveFarm
                .subscribe((farm)=>{
                    if(!_.isUndefined(farm)){
                       this.refresh();
                    }
                });
                this.mysynchDataStore.currentActiveHerd
                .subscribe((herd)=>{
                    if(!_.isUndefined(herd)){
                        this.refresh();
                    }
                });

                this.mysynchDataStore.currentUser
                .subscribe((user)=>{
                    if(!_.isUndefined(user)){
                            this.refresh();      
                    }
                });
              
                this.mysynchDataStore.currentPageType
                            .subscribe((pageType)=>{           
                                if(_.includes(['MultiFarm','Admin'],pageType) ){
                                   this.clearFarmSelection();        
                                }
                                this.currentPageType = _.cloneDeep(pageType);
                            });

                this.broadCastSrv.onFarmCreated()
                .subscribe((farm)=>{
                    this.refresh();      
                });

                this.broadCastSrv.onFarmUpdated()
                .subscribe((updatedCurrentActiveFarm)=>{
                  this.refresh();
                  if(!_.isUndefined(updatedCurrentActiveFarm) && !_.isNull(updatedCurrentActiveFarm) && !_.isEmpty(updatedCurrentActiveFarm)){
                        if(_.isEqual(_.get(updatedCurrentActiveFarm,'farmId'),_.get(this.inputs,'selectedFarm.farmId'))){
                            _.set(this.inputs,'selectedFarm',_.cloneDeep(updatedCurrentActiveFarm));
                        }
                    }
                });

                this.broadCastSrv.onFarmRemovedUser()
                .subscribe((removedUserFarm)=>{
                    this.refresh();  
                    if(!_.isUndefined(removedUserFarm) && !_.isNull(removedUserFarm) && !_.isEmpty(removedUserFarm)){
                        // if the farmId of the updated farm matches the farmId of the current selected farm, then we need to select the next available farm for the user if a farm is selected 
                        if(_.isEqual(_.get(removedUserFarm,'farmId'),_.get(this.inputs,'selectedFarm.farmId'))){

                            // inactivitiy check, if the farm was made inactive we need to select a different farm. However, no farms are normally selected  when farm is made inactive from the Farm Maint page.
                            _.set(this.inputs,'selectedFarm',_.cloneDeep(this.availableFarms[0]));
                            this.farmChanged(); 
                            
                        }
                    }
                });

                this.broadCastSrv.onFarmPreSelect()
                .subscribe((msgData)=>{
                    var selectedFarmId = _.cloneDeep(_.get(msgData,'farmId'));
                    var farm = _.find(this.availableFarms,{farmId: selectedFarmId});
                    if(!_.isUndefined(farm)){
                        _.set(this.inputs,'selectedFarm',farm);
                        _.set(this.prevSelectedFarm,'selectedFarm',_.cloneDeep(_.get(this.inputs,'selectedFarm')));
                        this.broadCastSrv.sendEnableSingleFarmLinksMsg("");
                    }    
                });

                this.broadCastSrv.onFarmHerdChange()
                .subscribe((msgData)=>{
                    var selectedFarm = _.cloneDeep(_.get(msgData,'farm'));
                    _.set(this.inputs,'selectedFarm',_.find(this.availableFarms,{farmId: _.get(selectedFarm,'farmId')}));
                    _.set(this.inputs,'selectedFarm.herds',_.get(msgData,'farmHerds'));
                    _.set(this.prevSelectedFarm,'selectedFarm',_.cloneDeep(_.get(this.inputs,'selectedFarm')));
           
                });


                if(!_.isUndefined(this.updateAvailableFarmsInterval)){
                    clearInterval(this.updateAvailableFarmsInterval);
                    this.updateAvailableFarmsInterval = setInterval(()=>{
                        var previousNumFarms = this.availableFarms.length;     
                        this.MSF.updateAvailableFarmListOptions().then((promiseData)=>{
                      
                            var previousHasOnlyNonDC305 = this.MSF.userHasOnlyNonDC305Farms();
                            this.MSF.updateAvailableHerdListOptions().then((promiseHerdData)=>{
                              this.MSF.updateAdditionalHerdDData().then((additionalHerdDataResults)=>{
                                    // // first thing
                                    // //need to add farm selection logic if the farm selected has been marked inactive or the user for the farm is marked in acive
                                    var currentSelectedFarmId = _.get(this.inputs.selectedFarm,'farmId');
                                    var currrentSelectedFarmHerds = _.get(this.inputs.selectedFarm,'herds');
                                    var availableFarms = this.MSF.getAvailableFarms();

                                    this.availableFarms = _.cloneDeep(availableFarms);
                                    this.buildFarmNameDisplay(this.availableFarms);

                                    var currentFarmMatch = _.find(this.availableFarms,{farmId: currentSelectedFarmId});
                                
                                    if(!_.isUndefined(currentSelectedFarmId)){
                                        if(_.isUndefined(currentFarmMatch)){
                                            if(this.availableFarms.length > 0){
                                                    _.set(this.inputs,'selectedFarm',_.cloneDeep(this.availableFarms[0]));
                                                    this.farmChanged(); 
                                            }else{
                                                this.MSF.logoutWithMessage("danger","This user account does not have access to any farms. Please contact your local Parnell Territory Manager with any questions.");
                                            }
                                        }else{
                                            _.set(currentFarmMatch,'herds',currrentSelectedFarmHerds);
                                            _.set(this.inputs,'selectedFarm',currentFarmMatch);					
                                        }
                                    }

                                    // need to check if a farm updated , removed or added needs to change the navigation
                                    if((!_.isEqual(previousNumFarms,this.availableFarms.length)) || !_.isEqual(previousHasOnlyNonDC305,this.MSF.userHasOnlyNonDC305Farms())){
                                        this.broadCastSrv.updateNavigationMsg({updateSections:[{name:"MultiFarmSection",sectionType:"MultiFarm"},{name:"SingleFarmSection",sectionType:"SingleFarm"}]});
                                    }
                              });
                            })
                        });
                    },900000); //900000 = 15 mins
                }else{
                    this.updateAvailableFarmsInterval =	setInterval(()=>{
                        var previousNumFarms = this.availableFarms.length;     
                        this.MSF.updateAvailableFarmListOptions().then((promiseData)=>{
                            var previousHasOnlyNonDC305 = this.MSF.userHasOnlyNonDC305Farms();
                            this.MSF.updateAvailableHerdListOptions().then((promiseHerdData)=>{
                                this.MSF.updateAdditionalHerdDData().then((additionalHerdDataResults)=>{
                          
                                        // // first thing
                                        // //need to add farm selection logic if the farm selected has been marked inactive or the user for the farm is marked in acive
                                        var currentSelectedFarmId = _.get(this.inputs.selectedFarm,'farmId');
                                        var currrentSelectedFarmHerds = _.get(this.inputs.selectedFarm,'herds');
                                        var availableFarms = this.MSF.getAvailableFarms();

                                        this.availableFarms = _.cloneDeep(availableFarms);
                                        this.buildFarmNameDisplay(this.availableFarms);
                                        
                                        var currentFarmMatch = _.find(this.availableFarms,{farmId: currentSelectedFarmId});

                                        if(!_.isUndefined(currentSelectedFarmId)){
                                            if(_.isUndefined(currentFarmMatch)){
                                                if(this.availableFarms.length > 0){
                                                        _.set(this.inputs,'selectedFarm',_.cloneDeep(this.availableFarms[0]));
                                                        this.farmChanged(); 
                                                }else{
                                                    this.MSF.logoutWithMessage("danger","This user account does not have access to any farms. Please contact your local Parnell Territory Manager with any questions.");
                                                }
                                            }else{
                                                _.set(currentFarmMatch,'herds',currrentSelectedFarmHerds);
                                                _.set(this.inputs,'selectedFarm',currentFarmMatch);					
                                            }
                                    }

                                        // need to check if a farm updated , removed or added needs to change the navigation
                                        if((!_.isEqual(previousNumFarms,this.availableFarms.length)) || !_.isEqual(previousHasOnlyNonDC305,this.MSF.userHasOnlyNonDC305Farms())){
                                            this.broadCastSrv.updateNavigationMsg({updateSections:[{name:"MultiFarmSection",sectionType:"MultiFarm"},{name:"SingleFarmSection",sectionType:"SingleFarm"}]});
                                        }
                                });
                            })
                        });
                    },900000); //900000 = 15 mins 
                } 

            });

        }

            
        }],
    });

})();